module.exports = __webpack_public_path__ + "img/mengHu4.fe3bb03c.png";